import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import api from '@frontend/api/axios';
import { useDebounce } from '@frontend/hooks/debounce';
import { useCoinPriceContext } from '@frontend/providers/CoinPriceProvider';
import { usePlatform } from '@frontend/providers/PlatformProvider';
import { useWalletConfig } from '@frontend/providers/WalletConfigProvider';
import { checkWalletOnChain } from '@frontend/utils/checkWalletOnChain';
import { findWallet } from '@frontend/utils/findWallet';
import { backendUrl, chainData } from '@jdiyield/constants';
import { useWeb3React } from '@web3-react/core';
import { useRouter } from 'next/router';
import * as React from 'react';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import throat from 'throat';
import { initialWallet, walletQuery } from './walletQuery';
var initialState = {
  wallets: [],
  totalNetWorth: 0,
  selectedProfile: 0,
  summaryTotalNetWorth: 0
};
var concurrentLoadWallet = 1;
var WalletInfoContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, initialState), {}, {
  loading: false,
  watchListInfo: [],
  summaryTotalNetWorth: 0,
  onSelectProfile: function onSelectProfile() {
    return null;
  },
  refetchWallets: function refetchWallets() {
    return null;
  }
}));
export var useWalletInfo = function useWalletInfo() {
  return useContext(WalletInfoContext);
};
export var WalletInfoProvider = function WalletInfoProvider(_ref) {
  var _walletsInfo$wallets;

  var children = _ref.children;

  var _useState = useState(initialState),
      walletsInfo = _useState[0],
      setWalletsInfo = _useState[1];

  var _useState2 = useState([]),
      watchListInfo = _useState2[0],
      setWatchListInfo = _useState2[1];

  var _usePlatform = usePlatform(),
      tokens = _usePlatform.tokens,
      platforms = _usePlatform.platforms,
      baseLpTokens = _usePlatform.baseLpTokens;

  var _useCoinPriceContext = useCoinPriceContext(),
      coinList = _useCoinPriceContext.coinList,
      CoinPriceLoading = _useCoinPriceContext.loading;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account,
      active = _useWeb3React.active;

  var _useWalletConfig = useWalletConfig(),
      profiles = _useWalletConfig.profiles,
      watchList = _useWalletConfig.watchList,
      proActivated = _useWalletConfig.proActivated;

  var _useState3 = useState(0),
      summaryTotalNetWorth = _useState3[0],
      setSummaryTotalNetWorth = _useState3[1];

  var router = useRouter();
  var allLoading = useDebounce((walletsInfo === null || walletsInfo === void 0 ? void 0 : (_walletsInfo$wallets = walletsInfo.wallets) === null || _walletsInfo$wallets === void 0 ? void 0 : _walletsInfo$wallets.some(function (_ref2) {
    var loading = _ref2.loading;
    return loading;
  })) || CoinPriceLoading, 1000);
  React.useEffect(function () {
    if (!allLoading) {
      if (walletsInfo.wallets.length !== 0) localStorage.setItem('walletsInfo', JSON.stringify(walletsInfo));
    }
  }, [allLoading, walletsInfo]);
  var setWallet = useCallback(function (_ref3) {
    var chainID = _ref3.chainID,
        address = _ref3.address;

    var dispatch = function dispatch(newState) {
      setWalletsInfo(function (prev) {
        var wallets = prev.wallets;
        var walletIndex = prev.wallets.findIndex(findWallet({
          chainId: chainID,
          account: address
        })); //? new wallet

        if (walletIndex === -1) {
          if (typeof newState === 'function') wallets = [].concat(_toConsumableArray(wallets), [newState(initialWallet)]);else wallets = [].concat(_toConsumableArray(wallets), [newState]);
        } else {
          //? Update wallet
          wallets[walletIndex] = typeof newState === 'function' ? newState(wallets[walletIndex]) : newState;
        }

        var totalNetWorth = wallets.reduce(function (prev, curr) {
          var totalDebt = curr.totalDebt,
              totalLPValue = curr.totalLPValue,
              totalReward = curr.totalReward,
              totalWallet = curr.totalWallet,
              totalWorth = curr.totalWorth,
              totalCollateral = curr.totalCollateral;
          return prev + (totalLPValue + totalReward + totalWallet + totalWorth + totalCollateral - totalDebt);
        }, 0);
        return _objectSpread(_objectSpread({}, prev), {}, {
          wallets: wallets,
          totalNetWorth: totalNetWorth
        });
      });
    };

    return dispatch;
  }, []);

  var handleGetHistoryPrice = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var result, sumTotalNetWorth;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api.get("".concat(backendUrl, "/net-worth/history/").concat(account, "?days=1"));

            case 3:
              result = _context.sent;
              sumTotalNetWorth = Object.keys(chainData).reduce(function (acc, key) {
                var _result$data$key;

                if (result !== null && result !== void 0 && (_result$data$key = result.data[key]) !== null && _result$data$key !== void 0 && _result$data$key.totalNetWorth[0]) {
                  var _result$data$key2;

                  acc = acc + (result === null || result === void 0 ? void 0 : (_result$data$key2 = result.data[key]) === null || _result$data$key2 === void 0 ? void 0 : _result$data$key2.totalNetWorth[0]);
                }

                return acc;
              }, 0);
              setSummaryTotalNetWorth(sumTotalNetWorth);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log('get history price fail');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function handleGetHistoryPrice() {
      return _ref4.apply(this, arguments);
    };
  }(); // React.useEffect(() => {
  //   if (account) {
  //     handleGetHistoryPrice()
  //   }
  // }, [account])


  React.useEffect(function () {
    var _router$query;

    var isHaveWatchAccount = !!(router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.wallet); // const selectedIndex = localStorage.getItem('selectedProfile')

    var saveWalletsInfo = localStorage.getItem('walletsInfo');
    setWalletsInfo(function (prev) {
      var walletsLoading = prev.wallets.some(function (_ref5) {
        var loading = _ref5.loading;
        return loading;
      });

      if (!walletsLoading) {
        var _JSON$parse;

        var saveWalletsInfoParse = (_JSON$parse = JSON.parse(saveWalletsInfo)) !== null && _JSON$parse !== void 0 ? _JSON$parse : prev;
        var selectedIndex = saveWalletsInfoParse.selectedProfile;

        if (selectedIndex < profiles.length && selectedIndex !== -1 && selectedIndex !== -2) {
          return _objectSpread(_objectSpread({}, saveWalletsInfoParse), {}, {
            selectedProfile: +selectedIndex
          });
        } else if (active) {
          return _objectSpread(_objectSpread({}, saveWalletsInfoParse), {}, {
            selectedProfile: -1
          });
        } else if (isHaveWatchAccount) {
          return _objectSpread(_objectSpread({}, saveWalletsInfoParse), {}, {
            selectedProfile: -2
          });
        } else {
          return _objectSpread(_objectSpread({}, saveWalletsInfoParse), {}, {
            selectedProfile: 0
          });
        }
      }

      return prev;
    });
  }, [active, profiles === null || profiles === void 0 ? void 0 : profiles.length, router === null || router === void 0 ? void 0 : router.query]);
  React.useEffect(function () {
    var queriesWallet = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var allWallets, _router$query2, watchAccount, allowChain, address, _allowChain, _profiles$walletsInfo, _profiles$walletsInfo2, _profiles$walletsInfo3, _profiles$walletsInfo4;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(Object.values(coinList).length === 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", null);

              case 2:
                allWallets = [];

                if (!(walletsInfo.selectedProfile === -2)) {
                  _context2.next = 16;
                  break;
                }

                watchAccount = router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.wallet;

                if (!watchAccount) {
                  _context2.next = 14;
                  break;
                }

                if (!watchAccount.slice(0, 2).includes('0x')) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 9;
                return checkWalletOnChain(watchAccount);

              case 9:
                allowChain = _context2.sent;
                allWallets = allowChain.map(function (chainID) {
                  return {
                    address: watchAccount,
                    chainID: chainID,
                    excludes: []
                  };
                });
                _context2.next = 14;
                break;

              case 13:
                if (watchAccount.slice(0, 5).includes('terra')) {
                  //TERRA
                  allWallets = [{
                    address: watchAccount,
                    chainID: 999,
                    excludes: []
                  }];
                } else if (watchAccount.slice(0, 6).includes('ronin:')) {
                  //RONIN
                  address = "".concat(watchAccount).replace('ronin:', '0x');
                  allWallets = [{
                    address: address,
                    chainID: 2020,
                    excludes: []
                  }];
                }

              case 14:
                _context2.next = 25;
                break;

              case 16:
                if (!(walletsInfo.selectedProfile === -1)) {
                  _context2.next = 24;
                  break;
                }

                if (!account) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 20;
                return checkWalletOnChain(account);

              case 20:
                _allowChain = _context2.sent;
                allWallets = _allowChain.map(function (chainID) {
                  return {
                    address: account,
                    chainID: chainID,
                    excludes: []
                  };
                });

              case 22:
                _context2.next = 25;
                break;

              case 24:
                allWallets = (_profiles$walletsInfo = profiles === null || profiles === void 0 ? void 0 : (_profiles$walletsInfo2 = profiles[walletsInfo.selectedProfile]) === null || _profiles$walletsInfo2 === void 0 ? void 0 : (_profiles$walletsInfo3 = _profiles$walletsInfo2.wallets) === null || _profiles$walletsInfo3 === void 0 ? void 0 : (_profiles$walletsInfo4 = _profiles$walletsInfo3.filter(function (_, i) {
                  return i < 5;
                })) === null || _profiles$walletsInfo4 === void 0 ? void 0 : _profiles$walletsInfo4.map(function (_ref7) {
                  var address = _ref7.address,
                      chainID = _ref7.chainID,
                      excludes = _ref7.excludes;
                  return {
                    address: address,
                    chainID: chainID,
                    excludes: excludes
                  };
                })) !== null && _profiles$walletsInfo !== void 0 ? _profiles$walletsInfo : [];

              case 25:
                //? filter after change account for clear old account
                //? and start loading
                setWalletsInfo(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    wallets: prev.wallets.filter(function (_ref8) {
                      var address = _ref8.address,
                          chainID = _ref8.chainID;
                      return allWallets.some(findWallet({
                        account: address,
                        chainId: chainID
                      }));
                    })
                  });
                });
                _context2.next = 28;
                return Promise.all(allWallets.map(throat(concurrentLoadWallet, walletQuery({
                  platforms: platforms,
                  tokens: tokens,
                  baseLpTokens: baseLpTokens,
                  coinList: coinList,
                  setWallet: setWallet
                }))));

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function queriesWallet() {
        return _ref6.apply(this, arguments);
      };
    }();

    queriesWallet();
  }, [account, coinList, platforms, profiles, setWallet, tokens, baseLpTokens, walletsInfo.selectedProfile, router === null || router === void 0 ? void 0 : router.query]);
  React.useEffect(function () {
    var main = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var watchListInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all(watchList.filter(function (_, index) {
                  if (!proActivated) return index === 0;else return true;
                }).map( /*#__PURE__*/function () {
                  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
                    var _allAssets$find$value, _allAssets$find;

                    var _yield$api$get, data, allAssets, value, _ref12, symbol, logo;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return api.get("".concat(backendUrl, "/prices/").concat(address, "?days=1"));

                          case 2:
                            _yield$api$get = _context3.sent;
                            data = _yield$api$get.data;
                            allAssets = [];
                            value = (_allAssets$find$value = (_allAssets$find = allAssets.find(function (_ref11) {
                              var currency = _ref11.currency;
                              return currency.address === address;
                            })) === null || _allAssets$find === void 0 ? void 0 : _allAssets$find.value) !== null && _allAssets$find$value !== void 0 ? _allAssets$find$value : 0;
                            _ref12 = tokens.find(function (token) {
                              return address === token.address;
                            }) || {
                              symbol: '??',
                              logo: null
                            }, symbol = _ref12.symbol, logo = _ref12.logo;
                            return _context3.abrupt("return", _objectSpread(_objectSpread({}, data), {}, {
                              balance: value,
                              address: address,
                              symbol: symbol,
                              logo: logo
                            }));

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref10.apply(this, arguments);
                  };
                }()));

              case 2:
                watchListInfo = _context4.sent;
                setWatchListInfo(watchListInfo || []);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function main() {
        return _ref9.apply(this, arguments);
      };
    }();

    main();
  }, [proActivated, tokens, watchList]);
  var onSelectProfile = useCallback(function (index) {
    setWalletsInfo(function (prev) {
      if (index === -2 || index === -1 || profiles.some(function (profile) {
        return profile.profileID === index;
      })) {
        localStorage.setItem('selectedProfile', index.toFixed());
        return _objectSpread(_objectSpread({}, prev), {}, {
          selectedProfile: index
        });
      } else return prev;
    });
  }, [profiles]);
  var refetchWallets = useCallback( /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(wallets) {
      var allWallets, _router$query3, watchAccount, allowChain, _allowChain2, _profiles$walletsInfo5, _profiles$walletsInfo6, _profiles$walletsInfo7;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(wallets.length === 0)) {
                _context5.next = 20;
                break;
              }

              allWallets = [];

              if (!(walletsInfo.selectedProfile === -2)) {
                _context5.next = 9;
                break;
              }

              watchAccount = router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.wallet;

              if (!watchAccount) {
                _context5.next = 9;
                break;
              }

              _context5.next = 7;
              return checkWalletOnChain(watchAccount);

            case 7:
              allowChain = _context5.sent;
              allWallets = allowChain.map(function (chainID) {
                return {
                  address: watchAccount,
                  chainID: chainID,
                  excludes: []
                };
              });

            case 9:
              if (!(walletsInfo.selectedProfile === -1)) {
                _context5.next = 17;
                break;
              }

              if (!account) {
                _context5.next = 15;
                break;
              }

              _context5.next = 13;
              return checkWalletOnChain(account);

            case 13:
              _allowChain2 = _context5.sent;
              allWallets = _allowChain2.map(function (chainID) {
                return {
                  address: account,
                  chainID: chainID,
                  excludes: []
                };
              });

            case 15:
              _context5.next = 18;
              break;

            case 17:
              allWallets = (_profiles$walletsInfo5 = profiles === null || profiles === void 0 ? void 0 : (_profiles$walletsInfo6 = profiles[walletsInfo.selectedProfile]) === null || _profiles$walletsInfo6 === void 0 ? void 0 : (_profiles$walletsInfo7 = _profiles$walletsInfo6.wallets) === null || _profiles$walletsInfo7 === void 0 ? void 0 : _profiles$walletsInfo7.map(function (_ref14) {
                var address = _ref14.address,
                    chainID = _ref14.chainID,
                    excludes = _ref14.excludes;
                return {
                  address: address,
                  chainID: chainID,
                  excludes: excludes
                };
              })) !== null && _profiles$walletsInfo5 !== void 0 ? _profiles$walletsInfo5 : [];

            case 18:
              _context5.next = 20;
              return Promise.all(allWallets.map(throat(concurrentLoadWallet, walletQuery({
                platforms: platforms,
                tokens: tokens,
                baseLpTokens: baseLpTokens,
                coinList: coinList,
                setWallet: setWallet
              }))));

            case 20:
              _context5.next = 22;
              return Promise.all(wallets.map(throat(concurrentLoadWallet, walletQuery({
                platforms: platforms,
                tokens: tokens,
                baseLpTokens: baseLpTokens,
                coinList: coinList,
                setWallet: setWallet
              }))));

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x2) {
      return _ref13.apply(this, arguments);
    };
  }(), [platforms, tokens, baseLpTokens, coinList, setWallet, walletsInfo.selectedProfile, router === null || router === void 0 ? void 0 : router.query, account, profiles]);
  var ctx = useMemo(function () {
    return _objectSpread(_objectSpread({}, walletsInfo), {}, {
      watchListInfo: watchListInfo,
      refetchWallets: refetchWallets,
      onSelectProfile: onSelectProfile,
      loading: allLoading,
      summaryTotalNetWorth: summaryTotalNetWorth
    });
  }, [allLoading, onSelectProfile, refetchWallets, walletsInfo, watchListInfo, summaryTotalNetWorth]);
  return _jsx(WalletInfoContext.Provider, {
    value: ctx,
    children: children
  });
};